import Hero from './Hero';
import WhatIDo from './WhatIDo';
import FeaturedProject from './FeaturedProject';
import HowIWork from './HowIWork';

export default function Home() {
  return (
    <>
      <Hero />
      <WhatIDo />
      <FeaturedProject />
      <HowIWork />
    </>
  );
}
